import { ref, computed } from 'vue'
import { firebase } from '@/api/firebase'

const user = ref(null)
const ready = ref(false)
let authReadyPromise = null

export function initAuth() {
  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve) => {
      let settled = false
      firebase.watchAuth((authUser) => {
        user.value = authUser
        if (!settled) {
          settled = true
          ready.value = true
          resolve(authUser)
        }
      })
    })
  }
  return authReadyPromise
}

export async function waitForAuth() {
  await initAuth()
}

export function useAuth() {
  const isAuthenticated = computed(() => Boolean(user.value))

  async function signOut() {
    await firebase.signOut()
    user.value = null
  }

  return {
    user,
    ready,
    isAuthenticated,
    signOut,
    waitForAuth,
  }
}
